export const PROPOSAL_TOAST_POSITION = 'bottom-right' as const;
